<div
  class="w-100 is-loading is-loading-{{ size }} py-{{ padding }}"
  *ngIf="loading"
>
  &nbsp;
</div>
